import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { CONFIG } from '../../constants/constants';
import { Answer } from "../../model/answer";
import { FileDTO } from "../../model/file";
import { WelcomeDTO } from "../../model/welcome.info";
import { TimeChrono } from "../../model/timeChrono";
import { ConfigurationService } from '../configuration/configuration.service';
import { CodResp } from '../../constants/codigosMensajes';
import { HistoricoCargue } from 'src/app/model/historicoCargue';
import { ConectionStatusDto } from 'src/app/model/conectionStatus.dto';
import { AnswerControlService } from '../answer/answerControl.service';
import { catchError, timeout } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { ConfigurationControlService } from '../configuration/configurationControl.service';
import { TokenControlService } from '../state/tokenControl.service';


/*Servicio para consumir rest services generales
  expuestos por plexi-rest */
@Injectable({
    providedIn: 'root'
})
export class RestService {


    //constructor de la clase
    constructor(
        private http: HttpClient,
        private _configurationService: ConfigurationService,
        private _answerController: AnswerControlService,
        private _tokenControlService: TokenControlService, 
        private _configurationControlService: ConfigurationControlService,
    ) {
        this.http = http;
    }


    /*Se encarga de enviar una respuesta a plexi-rest para
      sincronizarla con la base de datos principal del proyecto*/
    /*public postSynchronize(token: string, answer: Answer, user: string) {
        let self = this;
        return new Promise(
            resolve => {
                if (token) {
                    let _headers = new HttpHeaders({
                        'Content-Type': 'application/json',
                        'token': token,
                        'user': user
                    });
                    const options: {
                        headers?: HttpHeaders,
                        observe?: 'body',
                        params?: HttpParams,
                        reportProgress?: boolean,
                        responseType: 'text',
                        withCredentials?: boolean
                    } = {
                        headers: _headers,
                        responseType: 'text'
                    };
                    this.http.post(CONFIG.REST_END_POINT + 'saveAnswer/',
                        JSON.parse(JSON.stringify(answer)), options)
                        .subscribe(
                            (data: any) => {
                                resolve(data);
                            },
                            err => {
                                console.log(this._configurationService.getMessageByCode(err.error));
                                resolve(this._configurationService.getMessageByCode(err.error));
                            }
                        )
                        ;
                } else {
                    resolve(CodResp[1].codigo);
                }
            }
        );
    }*/

    /*Se encarga de enviar una respuesta a plexi-rest para
      sincronizarla con la base de datos principal del proyecto*/
    public postSynchronizeDeprecate(token: string, answer: Answer, user: string): Promise<any> {
        if (this._tokenControlService.isRoleReview()){
            return new Promise<void>((resolve, reject) => {
                resolve();
              });
        }

        if (answer.respuestaAbierta != null || answer.valorRespuesta != null) {
            const formData = new FormData();
            if (token) {
                const _headers = new HttpHeaders({
                    'token': token,
                    'user': user
                });

                answer.file = this._answerController.getFile(answer.credencialId, answer.itemId, answer.sesion)
               
                formData.append("file", answer.file);
                formData.append("data", JSON.stringify(answer));

                const options: {
                    headers?: HttpHeaders,
                    observe?: 'body',
                    params?: HttpParams,
                    reportProgress?: boolean,
                    responseType: 'text',
                    withCredentials?: boolean
                } = {
                    headers: _headers,
                    responseType: 'text'
                };
               
                return this.http.post(CONFIG.REST_END_POINT + 'saveAnswer/',
                formData, options).toPromise();
            }
        }
    }

    public async postSynchronize(token: string, answer: Answer, user: string): Promise<any> {
        if (this._tokenControlService.isRoleReview()){
            return new Promise<void>((resolve, reject) => {
                resolve();
              });
        }

        if (answer.respuestaAbierta != null || answer.valorRespuesta != null) {
          const formData = new FormData();
          if (token) {
            const _headers = new HttpHeaders({
              'token': token,
              'user': user
            });
    
            answer.file = this._answerController.getFile(answer.credencialId, answer.itemId, answer.sesion);
    
            formData.append("file", answer.file);
            formData.append("data", JSON.stringify(answer));
            
            const options: {
              headers?: HttpHeaders,
              observe?: 'body',
              params?: HttpParams,
              reportProgress?: boolean,
              responseType: 'text',
              withCredentials?: boolean
            } = {
              headers: _headers,
              responseType: 'text'
            };
            const timeoutDuration = this._configurationControlService.timeoutService; // Establecer el tiempo de espera en milisegundos
    
            return this.http.post(CONFIG.REST_END_POINT + 'saveAnswer/', formData, options).pipe(
              timeout(timeoutDuration),
              catchError(error => {
                if (error.name === 'TimeoutError') {
                  // Manejar el error de tiempo de espera
                  console.log('La solicitud excedió el tiempo de espera.');
                }
                return throwError(error);
              })
            ).toPromise();

            //return this.simulateLongRequest();
          }
        }
      }

    /*Se encarga de cambiarel estado de una sesion cuando esta termina*/
    public postEndSessionToken(token: string,
        credecial: number,
        session: number,
        enviarMail: Boolean,
        infoUser: WelcomeDTO,
        userName: string): Promise<string> {
        let self = this;
        console.log(infoUser);
        if (token) {
            let _headers = new HttpHeaders({
                'Content-Type': 'application/json',
                'token': token,
                'credentialId': credecial.toString(),
                'session': session.toString(),
                'enviarMail': enviarMail.toString(),
                'user': userName
            });
            const options: {
                headers?: HttpHeaders,
                observe?: 'body',
                params?: HttpParams,
                reportProgress?: boolean,
                responseType: 'text',
                withCredentials?: boolean
            } = {
                headers: _headers,
                responseType: 'text'
            };

            this.pruebasToString(infoUser);

            const timeoutDuration = this._configurationControlService.timeoutService; // Establecer el tiempo de espera en milisegundos
    
            return this.http.post(CONFIG.REST_END_POINT + 'endSessionToken/', infoUser, options).pipe(
              timeout(timeoutDuration),
              catchError(error => {
                if (error.name === 'TimeoutError') {
                  // Manejar el error de tiempo de espera
                  console.log('La solicitud excedió el tiempo de espera.');
                }
                return throwError(error);
              })
            ).toPromise();

        } else {
            console.log(CodResp[1].codigo);
        }
    }

    /** Metodo encargado de convertir el array de pruebas en string */
    private pruebasToString(infoUser: WelcomeDTO) {
        for (let i = 0; i < infoUser.sessions.length; i++) {
            let session = infoUser.sessions[i];
            for (let j = 0; j < session.subjects.length; j++) {
                let arrayPruebas: string[] = session.subjects[j].name;
                let namePrueba: string = "";
                for (let k = 0; k < arrayPruebas.length; k++) {
                    namePrueba += "-" + arrayPruebas[k];
                }
                session.subjects[j].name = namePrueba;
            }
        }
    }


    public verifyAnswerById(token: string, itemId: number, userName: string, userId: number): Promise<string> {
        let self = this;
        return new Promise(
            resolve => {
                if (token) {
                    let _headers = new HttpHeaders({
                        'Content-Type': 'application/json',
                        'token': token,
                        'itemId': itemId.toString(),
                        'user': userName,
                        'userId': userId.toString()
                    });
                    const options: {
                        headers?: HttpHeaders,
                        observe?: 'body',
                        params?: HttpParams,
                        reportProgress?: boolean,
                        responseType: 'text',
                        withCredentials?: boolean
                    } = {
                        headers: _headers,
                        responseType: 'text'
                    };
                    self.http.get(CONFIG.REST_END_POINT + 'verifyAnswerById/',
                        options)
                        .subscribe(
                            data => {
                                resolve(data);
                            },
                            err => {
                                console.log(this._configurationService.getMessageByCode(err.error));
                                resolve(this._configurationService.getMessageByCode(err.error));
                            }
                        );
                } else {
                    console.log(CodResp[1].codigo);
                    resolve(CodResp[1].codigo);
                }
            }
        );
    }


    public async updateAnswer(token: string,
        answerJson: Answer,
        userName: string): Promise<any> {
        let self = this;
        return new Promise(
            resolve => {
                if (token) {
                    const formData = new FormData();
                    const _headers = new HttpHeaders({
                        'token': token,
                        'user': userName
                    });
                    const options: {
                        headers?: HttpHeaders,
                        observe?: 'body',
                        params?: HttpParams,
                        reportProgress?: boolean,
                        responseType: 'text',
                        withCredentials?: boolean
                    } = {
                        headers: _headers,
                        responseType: 'text'
                    };

                    answerJson.file = this._answerController.getFile(answerJson.credencialId, answerJson.itemId, answerJson.sesion)
               
                    formData.append("file", answerJson.file);
                    formData.append("data", JSON.stringify(answerJson));
                    const timeoutDuration = this._configurationControlService.timeoutService;
                    this.http.post(CONFIG.REST_END_POINT + 'updateAnswer/',
                         formData, options)
                         .pipe(timeout(timeoutDuration))
                        .subscribe(
                            data => {
                                resolve(data);
                            },
                            err => {
                                console.log(this._configurationService.getMessageByCode(err.error));
                                resolve(this._configurationService.getMessageByCode(err.error));
                            }
                        );
                } else {
                    resolve(CodResp[1].codigo);
                }
            }
        );
    }


    public uploadFileDTO(token: string, fileDTO: FileDTO, userName: string): Promise<any> {
        let self = this;
        return new Promise(
            resolve => {
                if (token) {
                    let _headers = new HttpHeaders({
                        'Content-Type': 'application/json',
                        'token': token,
                        'user': userName
                    });
                    const options: {
                        headers?: HttpHeaders,
                        observe?: 'body',
                        params?: HttpParams,
                        reportProgress?: boolean,
                        responseType: 'text',
                        withCredentials?: boolean
                    } = {
                        headers: _headers,
                        responseType: 'text'
                    };
                    this.http.post(CONFIG.REST_END_POINT + 'uploadFile/',
                        JSON.stringify(fileDTO),
                        options)
                        .subscribe(
                            data => {
                                console.log(' devuelve promesa ' + data);
                                resolve(data.toString());

                            },
                            err => {
                                resolve(null);
                            }
                        );
                } else {
                    resolve(CodResp[1].codigo);
                }
            }
        );
    }

    private validTimeChrono(timeChrono: TimeChrono) {
        let valid = true;
        try {
            if (timeChrono.timeChrono) {
                const timeChronoJSON = JSON.parse(timeChrono.timeChrono);
                for (let index in timeChronoJSON) {
                    const valueTime = timeChronoJSON[index];
                    if (isNaN(valueTime)) {
                        valid = false;
                    }
                }
            } else {
                valid = false;
            }
        } catch (error) {
            valid = false;
        }

        return valid;
    }

    public saveTestChrono(token: string, timeChrono: TimeChrono, user: string): Promise<any> {
        let self = this;
        return new Promise(
            resolve => {
                if (token && this.validTimeChrono(timeChrono)) {
                    let _headers = new HttpHeaders({
                        'Content-Type': 'application/json',
                        'token': token,
                        'user': user
                    });
                    const options: {
                        headers?: HttpHeaders,
                        observe?: 'body',
                        params?: HttpParams,
                        reportProgress?: boolean,
                        responseType: 'text',
                        withCredentials?: boolean
                    } = {
                        headers: _headers,
                        responseType: 'text'
                    };
                    const timeoutDuration = this._configurationControlService.timeoutService;
                    this.http.post(CONFIG.REST_END_POINT + 'saveTimeChrono/',
                        JSON.stringify(timeChrono),
                        options)
                        .pipe(timeout(timeoutDuration))
                        .subscribe(
                            data => {
                                resolve(data.toString());

                            },
                            err => {
                                console.log(this._configurationService.getMessageByCode(err.error));
                                resolve(this._configurationService.getMessageByCode(err.error));
                            }
                        );
                } else {
                    resolve(null);
                }
            }
        );
    }

    public getTestChrono(token: string, credencialId: number, user: string) {
        let self = this;
        return new Promise<TimeChrono>(
            resolve => {
                if (token) {
                    let _headers = new HttpHeaders({
                        'Content-Type': 'application/json',
                        'token': token,
                        'user': user
                    });
                    const options: {
                        headers?: HttpHeaders,
                        observe?: 'body',
                        params?: HttpParams,
                        reportProgress?: boolean,
                        responseType: 'text',
                        withCredentials?: boolean
                    } = {
                        headers: _headers,
                        responseType: 'text'
                    };
                    this.http.post(CONFIG.REST_END_POINT + 'getTimeChrono/', credencialId,
                        { headers: _headers })
                        .subscribe(
                            (data: TimeChrono) => {
                                resolve(data);
                            },
                            err => {
                                resolve(null);
                            }
                        );

                } else {
                    resolve(null);
                }
            }
        );
    }

    public getLastEvent(idEstudiante, idExamen) {

        let _headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Cookie': 'CSRF_TOKEN=67d9c1d74e152e114a2ff9e8480fb4188b62b74b; PHPSESSID=205750bee4801dd9768f27569ec8c038'
        });

        return this.http.post<any>('https://icfes-config.edtest.ai/isolated_proctoring/examFeedback.php', {
            idExamen: idExamen, params: {
                matricula: idEstudiante,
                idExamen: idExamen
            }
        }, { headers: _headers })
    }

    public uploadHistoricoCargue(token: string, dataCarga: HistoricoCargue[], userName: string): Promise<any> {
        let self = this;
        return new Promise(
            resolve => {
                if (token) {
                    let _headers = new HttpHeaders({
                        'Content-Type': 'application/json',
                        'token': token,
                        'user': userName
                    });
                    const options: {
                        headers?: HttpHeaders,
                        observe?: 'body',
                        params?: HttpParams,
                        reportProgress?: boolean,
                        responseType: 'text',
                        withCredentials?: boolean
                    } = {
                        headers: _headers,
                        responseType: 'text'
                    };
                    this.http.post(CONFIG.REST_END_POINT + 'uploadHistoricoCargue/',
                        JSON.stringify(dataCarga),
                        options)
                        .subscribe(
                            data => {
                                console.log('Devuelve promesa cargue archivo offline: ' + data);
                                resolve(data.toString());
                            },
                            err => {
                                resolve(null);
                            }
                        );
                } else {
                    resolve(CodResp[1].codigo);
                }
            }
        );
    }

    /*Se encarga de actualizar la informacion de conexion o desconexion del usuario*/
    public saveConectionStatus(user: string, token: string, statusList: ConectionStatusDto[]): Promise<any> {

        let _headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'token': token,
            'user': user
        });

        return this.http.post<any>(CONFIG.REST_END_POINT + 'saveConectionStatus/', statusList,
            { headers: _headers, observe: 'response'})
            .toPromise();
    }

    /*Se encarga de borrar la credencial del usuario de la cache de redis*/
    public eliminarRedisCache(token: string, user: string): Promise<any> {
        let _headers = new HttpHeaders({
          'Content-Type': 'application/json',
          'token': token,
          'user': user,
          'credencialId': user
        });
    
        return this.http.get<Boolean>(CONFIG.REST_END_POINT + '/eliminarUsuarioActivoRedis', { headers: _headers })
        .toPromise()
        ;
      }

    public async uploadLambdaS3Contingencia(authorization: string, nombreArchivo: String, contenidoArchivo: string, usuario: string): Promise<any> {

        const _headers = new HttpHeaders({
            'Authorization': authorization,
            'Content-Type': 'application/json'//,
            //"Access-Control-Allow-Origin": "*"
            //"Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept"
        });

        const options: {
            headers?: HttpHeaders,
            observe?: 'body',
            params?: HttpParams,
            reportProgress?: boolean,
            responseType: 'json',
            withCredentials?: boolean
        } = {
            headers: _headers,
            responseType: 'json'
        };

        const data = {
            usuario: usuario,
            nombreArchivo: nombreArchivo,
            contenidoPlx: contenidoArchivo
        };

        return this.http.post(CONFIG.URL_LAMBDA_S3 + 'uploadplx', JSON.stringify(data), options).pipe(
            catchError(error => {
            return throwError(error);
            })
        ).toPromise();
    }

    public async prismaAutenticacacionTransversal(): Promise<any> {

        const _headers = new HttpHeaders({
            'apiToken': CONFIG.TOKEN_CERTIFICADO_ASISTENCIA,
            'Content-Type': 'application/json'            
        });

        const options: {
            headers?: HttpHeaders,
            observe?: 'body',
            params?: HttpParams,
            reportProgress?: boolean,
            responseType: 'json',
            withCredentials?: boolean
        } = {
            headers: _headers,
            responseType: 'json'
        };

        const data = {
            nombreAplicacion: CONFIG.APPLICATION_CERTIFICADO_ASSISTENCIA
        };

        return this.http.post(CONFIG.URL_AUTENTICACION_PRISMA + 'segurity/autenticacionTransversal', JSON.stringify(data), options).pipe(
            catchError(error => {
            return throwError(error);
            })
        ).toPromise();
    }

    public async prismaHabilitarCertificado(authorization: string,snp: string): Promise<any> {

        const _headers = new HttpHeaders({
            'Authorization': authorization,
            'Content-Type': 'application/json'
        });

        const options: {
            headers?: HttpHeaders,
            observe?: 'body',
            params?: HttpParams,
            reportProgress?: boolean,
            responseType: 'json',
            withCredentials?: boolean
        } = {
            headers: _headers,
            responseType: 'json'
        };

        const data = {
            snp: snp
        };

        return this.http.put(CONFIG.URL_HABILITAR_CERTIFICADO + 'certificados/habilitar-certificado', JSON.stringify(data), options).pipe(
            catchError(error => {
            return throwError(error);
            })
        ).toPromise();
    }

    public async prismaCertificadoAsistencia(authorization: string, documento:string, tipoDocumento: string, fechaNacimiento: string, periodo: string, exapId: string): Promise<any> {
        
        const _headers = new HttpHeaders({
            'Authorization': authorization,
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        const options: {
            headers?: HttpHeaders,
            observe?: 'body',
            params?: HttpParams,
            reportProgress?: boolean,
            responseType: 'arraybuffer',
            withCredentials?: boolean
        } = {
            headers: _headers,
            responseType: 'arraybuffer'
        };

        let params = new URLSearchParams();
        params.set('documento', documento);
        params.set('tipoDocumento', tipoDocumento);
        params.set('fechaNacimiento', fechaNacimiento);
        params.set('periodo', periodo);
        params.set('exapId', exapId);
        
        return this.http.post(CONFIG.URL_CERTIFICADO_ASISTENCIA + 'certificado-asistencia/api/certificados/generarPDF', params.toString(), options).         
        pipe(
            catchError(error => {
            return throwError(error);
            })
        ).toPromise();
    }

    public async prismaFirmaApostilla(authorization: string, idSignPosition: number, remitente: string, document: string   ): Promise<any> {

        const _headers = new HttpHeaders({
            'Authorization': authorization,
            'Content-Type': 'application/json',         
        });
        const options: {
            headers?: HttpHeaders,
            observe?: 'body',
            params?: HttpParams,
            reportProgress?: boolean,
            responseType: 'json',
            withCredentials?: boolean
        } = {
            headers: _headers,
            responseType: 'json'
        };

        const data = {
            'idSignPosition': idSignPosition,
            'remitente': remitente,
            'document': document,
            'signatureVisible': true
        };

        return this.http.post(CONFIG.URL_CERTIFICADO_ASISTENCIA + 'camerfirma/camerfirma/firmaApostillaNuevo', JSON.stringify(data), options).pipe(
            catchError(error => {
            return throwError(error);
            })
        ).toPromise();
    }

    public registrarCertificadoAsistencia(token: string, user: string, ordenJornada: number): Promise<any> {
        let self = this;
        let _headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'token': token,
            'user': user,
            'ordenJornada': ordenJornada.toString()
        });
        const options: {
            headers?: HttpHeaders,
            observe?: 'body',
            params?: HttpParams,
            reportProgress?: boolean,
            responseType: 'text',
            withCredentials?: boolean
        } = {
            headers: _headers,
            responseType: 'text'
        };
        
        const sessionInfo = self._configurationControlService.sessionInfo;
        const timeoutDuration = this._configurationControlService.timeoutService; // Establecer el tiempo de espera en milisegundos
    
        return this.http.post(CONFIG.REST_END_POINT + 'registarCertificadoAsistencia/', sessionInfo,  options)
            .pipe(
                timeout(timeoutDuration),
                catchError(error => {
                if (error.name === 'TimeoutError') {
                    // Manejar el error de tiempo de espera
                    console.log('La solicitud excedió el tiempo de espera.');
                }
                return throwError(error);
                })
            ).toPromise();
      }

}
